<template>
  <div>
    <ds-heading text="Tabela de feriados" />
    <ds-row>
      <ds-col size="2">
        <ds-button theme="primary" @click="onCreateHoliday">Adicionar feriado</ds-button>
      </ds-col>
      <ds-col size="1" offset="7">
        <ds-button
          full-width
          icon="chevron-left"
          @click="onPreviousYear">
        </ds-button>
      </ds-col>
      <ds-col size="1">
        <ds-heading
          :text="year"
          size="md"
          class="ds-u-text-align--center" />
      </ds-col>
      <ds-col size="1">
        <ds-button
          full-width
          icon="chevron-right"
          @click="onNextYear">
        </ds-button>
      </ds-col>
    </ds-row>

    <ds-row>
      <ds-col>
        <ds-async-content-wrapper
          :fetch-action="getHolidays"
          @fetch-success="setHolidays">
          <ds-table>
            <ds-tr slot="header">
              <ds-th>Data</ds-th>
              <ds-th>Descrição</ds-th>
              <ds-th></ds-th>
            </ds-tr>

            <ds-tr
              v-for="(holiday, index) in holidays"
              :key="index"
              not-hoverable>
              <ds-td>{{ holiday.data }}</ds-td>
              <ds-td>{{ holiday.descricao }}</ds-td>
              <ds-td>
                <ds-button
                  v-if="!holiday.padrao"
                  size="sm"
                  @click="onDelete(holiday.id, index)">
                  Excluir
                </ds-button>
              </ds-td>
            </ds-tr>
          </ds-table>
        </ds-async-content-wrapper>
      </ds-col>
    </ds-row>
  </div>
</template>

<script>
import moment from 'moment';
import CreateHolidayModal from './modals/CreateHolidayModal';
import { getHolidays, deleteHoliday } from './holidayService';

export default {
  name: 'HolidayPage',
  data() {
    return {
      holidays: null,
      year: moment().format('YYYY'),
    };
  },
  computed: {
    nextYear() {
      return moment(parseInt(this.year) + 1, 'YYYY').format('YYYY');
    },
    previousYear() {
      return moment(parseInt(this.year) - 1, 'YYYY').format('YYYY');
    },
  },
  methods: {
    getHolidays() {
      return getHolidays(this.year);
    },
    setHolidays(response) {
      this.holidays = response;
    },
    onDelete(id, index) {
      this.$caConfirm({
        title: 'Excluir feriado',
        message: 'Você está prestes a excluir o registro <b>Feriado</b>.'
               + ' Uma vez feita esta ação não poderá ser desfeita.'
               + ' Você tem certeza de que deseja excluir este registro?',
        confirmButtonText: 'Excluir registro',
        onConfirm: () => {
          deleteHoliday(id)
            .then(() => {
              this.$delete(this.holidays, index);
              this.$toaster.success('Feriado excluído com sucesso.');
            })
            .catch(() => {
              this.$toaster.error('Erro ao excluir feriado');
            });
        },
      });
    },
    onCreateHoliday() {
      this.$dialogModal(CreateHolidayModal, {
        props: {
          year: this.year,
        },
        on: {
          created: () => {
            this.getHolidays().then(response => this.setHolidays(response));
          },
        },
      }).open();
    },
    onPreviousYear() {
      this.year--;
      this.getHolidays().then(response => this.setHolidays(response));
    },
    onNextYear() {
      this.year++;
      this.getHolidays().then(response => this.setHolidays(response));
    },
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>
